function Loading() {
  return (
    <div>
      <div className="content">
        <div className="loading">
          <p>loading</p>
          <span></span>
        </div>
      </div>
    </div>
  );
}
export default Loading;
